








import { Component, Prop, Vue } from 'vue-property-decorator'
import { RawLocation} from 'vue-router'

export interface Navlink {
  target: RawLocation,
  message: string,
  exact?: boolean,
}

@Component
export class AppNavbarNavlinks extends Vue {
  @Prop({ default: [] }) private navlinks!: Navlink[]
}
export default AppNavbarNavlinks
